var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"omapi-template-preview__new-badge om-new-badge"},[_vm._t("default",function(){return [_vm._v("New")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }